var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.participations,
      columns: _vm.columns,
      "row-key": "id",
      pagination: _vm.pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      },
      request: _vm.requestParticipations
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t(col.label)) +
                    "\n            "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c("q-td", { key: "id", attrs: { props: props } }, [
                  _vm._v(
                    "\n\t                " +
                      _vm._s(props.row.id) +
                      "\n                "
                  )
                ]),
                _c("q-td", { key: "title", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(props.row.title) +
                      "\n                "
                  )
                ]),
                _c("q-td", { key: "qtd_audios", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(props.row.qtd_audios) +
                      "\n                "
                  )
                ]),
                _c("q-td", { key: "progress", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(props.row.progress) +
                      "\n                "
                  )
                ]),
                _c("q-td", { key: "date_listen", attrs: { props: props } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.fDate(props.row.date_listen)) +
                      "\n                "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "status", attrs: { props: props } },
                  [
                    _c(
                      "q-chip",
                      {
                        attrs: {
                          small: "",
                          color: _vm.getStatusColorChip(props.row.status)
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }